import { useParams, useSearchParams } from 'react-router-dom';

export enum TABS_OPTIONS {
    Source = 'source',
    Header = 'header',
    EmailDocument = 'email-document',
    Document = 'document',
    Emails = 'emails',
    Attachments = 'attachments',
    ProcessingHistory = 'processing-history',
    VoiceConversation = 'voice-conversation',
    MasterData = 'master-data',
}

export const useCurrentTabName = (): TABS_OPTIONS => {
    const { tab } = useParams();
    const [searchParams] = useSearchParams();

    switch (tab) {
        case TABS_OPTIONS.Document:
            switch (searchParams.get('mode')) {
                case TABS_OPTIONS.Attachments:
                    return TABS_OPTIONS.Attachments;
                default:
                    return TABS_OPTIONS.Document;
            }
        case TABS_OPTIONS.EmailDocument:
            return TABS_OPTIONS.EmailDocument;
        case TABS_OPTIONS.Source:
            return TABS_OPTIONS.Source;
        case TABS_OPTIONS.Emails:
            return TABS_OPTIONS.Emails;
        case TABS_OPTIONS.ProcessingHistory:
            return TABS_OPTIONS.ProcessingHistory;
        case TABS_OPTIONS.VoiceConversation:
            return TABS_OPTIONS.VoiceConversation;
        case TABS_OPTIONS.MasterData:
            return TABS_OPTIONS.MasterData;
        default:
            return TABS_OPTIONS.Document;
    }
};
